import { ALLOCATIONS, EXPERIMENTS } from '@fiverr-private/listing_experiments';

export const shouldShowSideFilters = (isBusiness: boolean, isTouch: boolean, abTests: Record<string, number>) =>
    !isBusiness &&
    !isTouch &&
    Number(abTests[EXPERIMENTS.HAWKS_LISTINGS_SELLER_LANGUAGE_SIDE_FILTERS]) > Number(ALLOCATIONS.CONTROL);
